module.exports = __webpack_public_path__ + "img/rfp.98809693.svg";